import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-horizontal-divider',
  imports: [],
  templateUrl: './horizontal-divider.component.html',
  styleUrl: './horizontal-divider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalDividerComponent {
  noBottomMargin = input<boolean>(false);
  margin8 = input<boolean>(false);

  @HostBinding('class.mr-8')
  get isMargin8() {
    return this.margin8();
  }

  @HostBinding('class.no-bottom-margin')
  get is32Padding() {
    return this.noBottomMargin();
  }

}
